import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=0a63fc4a&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=0a63fc4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63fc4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a63fc4a')) {
      api.createRecord('0a63fc4a', component.options)
    } else {
      api.reload('0a63fc4a', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=0a63fc4a&scoped=true&", function () {
      api.rerender('0a63fc4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zqB9IsqZjVVX/JS/comp/DateRange.vue"
export default component.exports